import React, { useState } from "react";
import { ASSETS } from "../../../../../../../utils/config.js";
import * as Styled from "./styles.js";
import AlignmentItem from "../AlignmentItem/index.jsx";

function AlignmentBox({ selectedAlignment, handleAlignmentChange, isActive }) {
  return (
    <Styled.Container>
      <Styled.SizeHeading>Alignment</Styled.SizeHeading>
      <Styled.RowDiv>
        <AlignmentItem
          isActive={isActive}
          isSelected={selectedAlignment === "left"}
          image={ASSETS.segmentEditor.LeftAlignment}
          onClick={() => handleAlignmentChange("left")}
        />
        <AlignmentItem
          isActive={isActive}
          isSelected={selectedAlignment === "center"}
          image={ASSETS.segmentEditor.CenterAlignment}
          onClick={() => handleAlignmentChange("center")}
        />
        <AlignmentItem
          isActive={isActive}
          isSelected={selectedAlignment === "right"}
          image={ASSETS.segmentEditor.RightAlignment}
          onClick={() => handleAlignmentChange("right")}
        />
      </Styled.RowDiv>
    </Styled.Container>
  );
}

export default AlignmentBox;
